/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptsControllerRemoveMutationResponse, PromptsControllerRemovePathParams, PromptsControllerRemove401, PromptsControllerRemove403, PromptsControllerRemove404 } from "../../models/promptsController/PromptsControllerRemove";

function getPromptsControllerRemoveUrl(id: PromptsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/prompts/${id}` as const }  
  return res
}

/**
 * @summary Delete a prompt (soft delete)
 * {@link /api/v1/prompts/:id}
 */
export async function promptsControllerRemove(id: PromptsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptsControllerRemoveMutationResponse, ResponseErrorConfig<PromptsControllerRemove401 | PromptsControllerRemove403 | PromptsControllerRemove404>, unknown>({ method : "DELETE", url : getPromptsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}